import {defaultClassNames} from '../../constants';

export const removeTargetList = (element: HTMLElement | null): void => {
    if (element) {
        const {classList} = element;
        const uselessClassList = [
            defaultClassNames.targetClassName,
            defaultClassNames.targetRight,
            defaultClassNames.targetLeft,
            defaultClassNames.targetTop,
            defaultClassNames.targetBottom,
        ];

        uselessClassList.forEach(className => {
            if (classList.contains(className)) {
                classList.remove(className);
            }
        });
    }
};
